// Sentry must initialize before any other app code runs.
import { initSentry } from './utils/sentry';

initSentry();

